import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserTenantsDTO } from '@core/model';
import { HomeService } from '@core/service/home.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomeResolver  {
  constructor(private homeService: HomeService, private router: Router) {}

  resolve(): Observable<UserTenantsDTO> {
    return this.homeService.getTenants().pipe(
      catchError(() => {
        this.router.navigate(['/404']);
        
        return EMPTY;
      })
    );
  }
}
